export default {
  "title": "Política de privacidad de DeMaxtore.com",
  "subtitle": "Esta política de privacidad explica cómo Demakstore Gıda İhracat San. ve Tic. Ltd. Şti., que opera la marca DeMaxtore, recopila y trata datos personales y empresariales.",
  "lastUpdated": "Última actualización: 26 de mayo de 2026",
  "back": "← Volver al inicio",
  "sections": [
    {
      "title": "1. Acerca de DeMaxtore",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore es la marca y la plataforma digital operada por Demakstore Gıda İhracat San. ve Tic. Ltd. Şti."
        },
        {
          "type": "p",
          "text": "DeMaxtore es una plataforma B2B que ayuda a los compradores internacionales a obtener productos de fabricantes turcos verificados, comparar ofertas de flete, gestionar procesos de inspección y realizar un seguimiento de los envíos desde la recogida en fábrica hasta la entrega en almacén."
        },
        {
          "type": "p",
          "text": "Dichos servicios pueden incluir, entre otros:"
        },
        {
          "type": "ul",
          "items": [
            "Directorio de proveedores y servicios de listado de fabricantes",
            "Herramientas de consulta del comprador y comunicación con el proveedor",
            "Procesos de abastecimiento y licitación de CommodityBid",
            "Servicios de comparación de fletes de FreightIQ",
            "Coordinación de la inspección",
            "Rastreo del envío",
            "Gestión de procesos de importación y servicios de soporte relacionados"
          ]
        }
      ]
    },
    {
      "title": "Datos personales que recopilamos",
      "blocks": [
        {
          "type": "p",
          "text": "Podemos recopilar datos personales directamente de usuarios, empresas, proveedores, compradores, proveedores de logística u otros socios comerciales cuando utilizan nuestro sitio web o servicios."
        },
        {
          "type": "p",
          "text": "Los Datos Personales que podemos recopilar incluyen:"
        },
        {
          "type": "ul",
          "items": [
            "Nombre completo",
            "Nombre de la empresa",
            "Cargo o departamento",
            "Dirección de correo electrónico comercial",
            "Número de teléfono",
            "País y ciudad",
            "Página web de la empresa",
            "Solicitudes de abastecimiento de productos",
            "Información del proveedor o fabricante",
            "Información relacionada con el flete, el envío y la entrega",
            "Detalles de la solicitud de inspección",
            "Mensajes, consultas, formularios y registros de comunicación",
            "Información de inicio de sesión de la cuenta, si corresponde",
            "Dirección IP, tipo de navegador, información del dispositivo y datos de uso del sitio web"
          ]
        },
        {
          "type": "p",
          "text": "Por lo general, procesamos la información en un contexto B2B y no recopilamos intencionalmente datos personales confidenciales a menos que el usuario los proporcione voluntariamente y sean necesarios para un servicio específico."
        }
      ]
    },
    {
      "title": "Cómo recopilamos sus datos personales",
      "blocks": [
        {
          "type": "p",
          "text": "Podemos recopilar datos personales cuando usted:"
        },
        {
          "type": "ul",
          "items": [
            "Visite www.demaxtore.com",
            "Completa un formulario de contacto",
            "Enviar una solicitud de abastecimiento",
            "Crear o utilizar una cuenta de comprador o proveedor",
            "Usar CommodityBid",
            "Usar FreightIQ",
            "Solicitar comparación de flete",
            "Solicitar servicios de inspección",
            "Solicitar soporte de seguimiento de envíos",
            "Ponte en contacto con nosotros por correo electrónico, teléfono, WhatsApp u otros canales de comunicación",
            "Suscríbase a actualizaciones, boletines informativos o comunicaciones comerciales",
            "Comuníquese con los representantes de DeMaxtore"
          ]
        },
        {
          "type": "p",
          "text": "También podemos recibir información comercial de proveedores, fabricantes, socios logísticos, socios de inspección o fuentes comerciales disponibles públicamente cuando la ley lo permita."
        }
      ]
    },
    {
      "title": "Finalidades del tratamiento de datos personales",
      "blocks": [
        {
          "type": "p",
          "text": "Procesamos datos personales con los siguientes propósitos:"
        },
        {
          "type": "ul",
          "items": [
            "Para proporcionar acceso al sitio web y los servicios de Demaxtore",
            "Gestionar las consultas de compradores y proveedores",
            "Conectar a los compradores con proveedores o fabricantes relevantes",
            "Para procesar solicitudes de abastecimiento a través de CommodityBid",
            "Para comparar las ofertas de flete a través de FreightIQ",
            "Coordinar los servicios de inspección y seguimiento de envíos",
            "Comunicarse con usuarios, compradores, proveedores y socios logísticos",
            "Para proporcionar soporte técnico al cliente",
            "Para verificar la información de la empresa o del proveedor",
            "Para mejorar nuestro sitio web, servicios y experiencia del usuario",
            "Para enviar comunicaciones comerciales, de servicio o de marketing",
            "Para evitar el fraude, el uso indebido, el spam o la actividad no autorizada",
            "Cumplir con las obligaciones legales, contractuales, reglamentarias o fiscales",
            "Para proteger los derechos, la seguridad, la reputación y los intereses legítimos de DeMaxtore"
          ]
        }
      ]
    },
    {
      "title": "FUNDAMENTO JURÍDICO DEL TRATAMIENTO DE DATOS",
      "blocks": [
        {
          "type": "p",
          "text": "Cuando corresponda en virtud del RGPD o leyes de protección de datos similares, procesamos datos personales en función de uno o más de los siguientes motivos legales:"
        },
        {
          "type": "ul",
          "items": [
            "Ejecución de un contrato: cuando el procesamiento es necesario para prestar nuestros servicios",
            "Interés legítimo: para la comunicación B2B, la mejora del servicio, la prevención del fraude, la coordinación del abastecimiento, la coordinación logística y el desarrollo comercial",
            "Consent: where users give consent for marketing communications, cookies, or optional communications",
            "Legal obligation: where processing is required by applicable law, regulation, court order, or public authority request"
          ]
        },
        {
          "type": "p",
          "text": "Users may withdraw consent at any time where processing is based on consent."
        }
      ]
    },
    {
      "title": "6. Sharing of Personal Data",
      "blocks": [
        {
          "type": "p",
          "text": "In order to provide our services, we may share relevant personal or business data with:"
        },
        {
          "type": "ul",
          "items": [
            "Verified suppliers and manufacturers",
            "Buyers who submit sourcing requests",
            "Freight forwarders and logistics partners",
            "Inspection service providers",
            "Payment, accounting, legal, or compliance service providers",
            "IT infrastructure, hosting, CRM, email, analytics, and cloud service providers",
            "Business consultants or authorized DeMaxtore representatives",
            "Public authorities, courts, or regulators where legally required"
          ]
        },
        {
          "type": "p",
          "text": "For example, when a buyer submits a sourcing request, certain business contact details and request details may be shared with relevant suppliers or service partners to facilitate the sourcing process."
        },
        {
          "type": "p",
          "text": "We do not sell personal data to third parties."
        }
      ]
    },
    {
      "title": "7. Supplier Directory and Company Profiles",
      "blocks": [
        {
          "type": "p",
          "text": "Demaxtore may display company-related information in its supplier directory or platform interface. This may include:"
        },
        {
          "type": "ul",
          "items": [
            "Company name",
            "Product categories",
            "Country or city",
            "Business description",
            "Company website",
            "Contact or inquiry options",
            "Verification status",
            "Relevant business details provided by the company"
          ]
        },
        {
          "type": "p",
          "text": "Companies are responsible for ensuring that the information they provide is accurate, lawful, up to date, and does not infringe the rights of any third party."
        }
      ]
    },
    {
      "title": "8. Messaging, Contact Forms, and Inquiries",
      "blocks": [
        {
          "type": "p",
          "text": "When users send inquiries, messages, or sourcing requests through DeMaxtore, the content of these communications may be reviewed by DeMaxtore’s team for operational, support, quality, compliance, and service management purposes."
        },
        {
          "type": "p",
          "text": "Messages may also be shared with relevant suppliers, buyers, logistics providers, inspection partners, or other parties involved in the requested service."
        },
        {
          "type": "p",
          "text": "Users must not submit unlawful, misleading, offensive, fraudulent, spam-related, or third-party-infringing content through our website or services."
        }
      ]
    },
    {
      "title": "9. CommodityBid Data",
      "blocks": [
        {
          "type": "p",
          "text": "When using CommodityBid, we may process information such as:"
        },
        {
          "type": "ul",
          "items": [
            "Buyer sourcing requests",
            "Product specifications",
            "Quantity, packaging, and delivery expectations",
            "Target price or bidding details",
            "Supplier offers",
            "Company and contact information",
            "Communication records related to the bidding process"
          ]
        },
        {
          "type": "p",
          "text": "This data is used to manage structured B2B bidding processes between buyers and verified suppliers or manufacturers."
        }
      ]
    },
    {
      "title": "10. FreightIQ and Shipment Data",
      "blocks": [
        {
          "type": "p",
          "text": "When using FreightIQ, freight comparison, or shipment tracking services, we may process data such as:"
        },
        {
          "type": "ul",
          "items": [
            "Pickup and delivery details",
            "Shipment type",
            "Product or cargo information",
            "Freight requirements",
            "Forwarder offers",
            "Tracking updates",
            "Customs or documentation-related business information",
            "Contact details of buyers, suppliers, and logistics partners"
          ]
        },
        {
          "type": "p",
          "text": "This data is used to compare freight options, coordinate logistics, and support door-to-door shipment visibility."
        }
      ]
    },
    {
      "title": "11. Inspection Services Data",
      "blocks": [
        {
          "type": "p",
          "text": "When inspection services are requested, we may process:"
        },
        {
          "type": "ul",
          "items": [
            "Product details",
            "Factory or supplier information",
            "Inspection location",
            "Inspection requirements",
            "Photos, reports, or quality control documents",
            "Contact details of relevant parties"
          ]
        },
        {
          "type": "p",
          "text": "This information is used to coordinate inspection services and communicate inspection results to the relevant business parties."
        }
      ]
    },
    {
      "title": "12. WhatsApp Business and Other Communication Channels",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore may use WhatsApp Business, email, phone, SMS, or other communication channels to communicate with users, buyers, suppliers, and business partners."
        },
        {
          "type": "p",
          "text": "If you contact us through WhatsApp or another third-party communication tool, your communication may also be subject to the privacy policy of that third-party provider."
        },
        {
          "type": "p",
          "text": "We may store communication records for business, support, legal, or service quality purposes unless deletion is requested and no legal retention obligation applies."
        }
      ]
    },
    {
      "title": "13. Cookies and Similar Technologies",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore may use cookies and similar technologies to:"
        },
        {
          "type": "ul",
          "items": [
            "Ensure website functionality",
            "Improve user experience",
            "Analyze website traffic",
            "Remember user preferences",
            "Support security and fraud prevention",
            "Measure marketing performance"
          ]
        },
        {
          "type": "p",
          "text": "Users may manage or disable cookies through their browser settings. Some website features may not function properly if cookies are disabled."
        }
      ]
    },
    {
      "title": "14. Marketing Communications",
      "blocks": [
        {
          "type": "p",
          "text": "We may contact users and business representatives by email, phone, WhatsApp, or other communication channels for service-related or commercial purposes, where permitted by law."
        },
        {
          "type": "p",
          "text": "Users may opt out of marketing communications at any time by contacting us or using the unsubscribe option where available."
        },
        {
          "type": "p",
          "text": "Even after opting out, we may still send service-related, transactional, legal, or security communications where necessary."
        }
      ]
    },
    {
      "title": "15. International Data Transfers",
      "blocks": [
        {
          "type": "p",
          "text": "Because DeMaxtore operates in an international B2B trade environment, personal data may be transferred to or accessed from countries outside the user’s country of residence."
        },
        {
          "type": "p",
          "text": "Where required by applicable law, we take appropriate safeguards to protect personal data during international transfers, including contractual, technical, and organizational measures."
        }
      ]
    },
    {
      "title": "16. Data Retention",
      "blocks": [
        {
          "type": "p",
          "text": "We retain personal data only for as long as necessary for the purposes described in this Privacy Policy, including:"
        },
        {
          "type": "ul",
          "items": [
            "Providing services",
            "Managing business relationships",
            "Handling sourcing, logistics, bidding, and inspection processes",
            "Complying with legal and tax obligations",
            "Resolving disputes",
            "Preventing fraud or misuse",
            "Maintaining business records"
          ]
        },
        {
          "type": "p",
          "text": "When personal data is no longer required, we delete, anonymize, or securely archive it in accordance with applicable laws and internal retention practices."
        }
      ]
    },
    {
      "title": "17. Data Security",
      "blocks": [
        {
          "type": "p",
          "text": "We take reasonable technical and organizational measures to protect personal data against:"
        },
        {
          "type": "ul",
          "items": [
            "Unauthorized access",
            "Accidental loss",
            "Misuse",
            "Alteration",
            "Disclosure",
            "Destruction",
            "Security incidents"
          ]
        },
        {
          "type": "p",
          "text": "However, no internet-based system can be guaranteed to be completely secure. Users are responsible for keeping their account login details confidential and notifying us immediately in case of unauthorized access or suspected security issues."
        }
      ]
    },
    {
      "title": "18. User Rights",
      "blocks": [
        {
          "type": "p",
          "text": "Depending on applicable data protection laws, users may have the right to:"
        },
        {
          "type": "ul",
          "items": [
            "Access their personal data",
            "Request correction of inaccurate data",
            "Request deletion of personal data",
            "Object to certain processing activities",
            "Restrict processing",
            "Withdraw consent",
            "Request data portability",
            "Lodge a complaint with a competent data protection authority"
          ]
        },
        {
          "type": "p",
          "text": "To exercise these rights, users may contact DeMaxtore using the contact details provided below."
        }
      ]
    },
    {
      "title": "19. Third-Party Websites and Services",
      "blocks": [
        {
          "type": "p",
          "text": "Our website may contain links to third-party websites, platforms, logistics providers, suppliers, manufacturers, or service providers."
        },
        {
          "type": "p",
          "text": "DeMaxtore is not responsible for the privacy practices, content, security, or policies of third-party websites or services. Users should review the privacy policies of those third parties before sharing personal data with them."
        }
      ]
    },
    {
      "title": "20. Children’s Privacy",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore’s services are intended for business users and are not directed to children. We do not knowingly collect personal data from individuals under the age of 18."
        },
        {
          "type": "p",
          "text": "If we become aware that we have collected personal data from a child without appropriate authorization, we will take reasonable steps to delete such data."
        }
      ]
    },
    {
      "title": "21. Changes to This Privacy Policy",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore may update this Privacy Policy from time to time to reflect changes in our services, legal requirements, business operations, or data processing practices."
        },
        {
          "type": "p",
          "text": "The updated version will be published on www.demaxtore.com with the revised “Last Updated” date. Continued use of our website or services after publication of changes means that users acknowledge the updated Privacy Policy."
        }
      ]
    },
    {
      "title": "22. Contact",
      "blocks": [
        {
          "type": "p",
          "text": "For questions, requests, or complaints regarding this Privacy Policy or the processing of personal data, please contact us:"
        },
        {
          "type": "ul",
          "items": [
            "Demakstore Gıda İhracat San. ve Tic. Ltd. Şti.",
            "Operating Brand: DeMaxtore",
            "Website: www.demaxtore.com",
            "Email: support@demaxtore.com",
            "Alternative Email: demaxtore@demaxtore.com"
          ]
        }
      ]
    }
  ]
};
